/**
 * Sistema de notificaciones global simplificado
 *
 * Este script proporciona una función global 'notification()' que puede ser llamada desde cualquier parte
 * para mostrar notificaciones al usuario.
 * 
 * Uso:
 * - Mostrar una notificación: notification('Tu mensaje');
 * - Con más opciones: notification('Tu mensaje', 'error', 5000);
 */

// Self-invoking function para evitar contaminar el espacio global
(function () {
  // Variable para almacenar el timeout actual
  let currentTimeout = null;

  // Crear los elementos de la notificación si no existen
  function createNotificationElements() {
    // Si ya existe el contenedor, no hacer nada
    if (document.getElementById('notification-message')) {
      return;
    }
    
    // Crear el overlay
    const overlay = document.createElement('div');
    overlay.id = 'notification-overlay';
    overlay.className = 'notification-overlay';
    overlay.style.display = 'none';

    // Crear el contenedor
    const container = document.createElement('div');
    container.id = 'notification-message';
    container.className = 'notification-message notification-message--error';
    container.style.display = 'none';

    // Crear el elemento de texto
    const messageText = document.createElement('div');
    messageText.id = 'notification-message-text';
    messageText.className = 'notification-message__text';

    // Crear el botón de cerrar
    const closeButton = document.createElement('button');
    closeButton.id = 'notification-message-close';
    closeButton.className = 'notification-message__close';
    closeButton.setAttribute('aria-label', 'Cerrar');
    closeButton.innerHTML = '&times;';

    // Añadir los elementos al contenedor
    container.appendChild(messageText);
    container.appendChild(closeButton);

    // Añadir el overlay y el contenedor al body
    document.body.appendChild(overlay);
    document.body.appendChild(container);

    // Añadir evento al botón de cerrar
    closeButton.addEventListener('click', hideNotification);
  }

  // Añadir los estilos CSS
  function addStyles() {
    if (document.getElementById('notification-styles')) {
      return;
    }

    const style = document.createElement('style');
    style.id = 'notification-styles';
    style.textContent = `
      .notification-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 9998;
        opacity: 0;
        transition: opacity 0.3s ease;
      }
      
      .notification-message {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 15px 20px;
        border-radius: 4px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
        display: flex;
        align-items: center;
        justify-content: space-between;
        z-index: 9999;
        width: 90%;
        max-width: 500px;
        opacity: 0;
        transition: opacity 0.3s ease;
      }



      .notification-message--error {
        background-color: #f8d7da;
        color: #721c24;
        border: 1px solid #dd8791;
      }

      .notification-message--success {
        background-color: #d4edda;
        color: #155724;
        border: 1px solid #c3e6cb;
      }

      .notification-message--warning {
        background-color: #fff3cd;
        color: #856404;
        border: 1px solid #ffeeba;
      }

      .notification-message--info {
        background-color: #d1ecf1;
        color: #0c5460;
        border: 1px solid #bee5eb;
      }

      .notification-message__text {
        flex: 1;
        margin-right: 10px;
        font-size: 15px;
      }

      .notification-message__close {
        background: none;
        border: none;
        font-size: 20px;
        cursor: pointer;
        padding: 0;
        color: inherit;
        opacity: 0.7;
      }

      .notification-message__close:hover {
        opacity: 1;
      }
    `;

    document.head.appendChild(style);
  }

  // Función para mostrar una notificación
  function showNotification(message, type = 'error', duration = 0) {
    // Asegurarse de que los elementos existen
    createNotificationElements();

    // Obtener los elementos
    const overlay = document.getElementById('notification-overlay');
    const container = document.getElementById('notification-message');
    const messageText = document.getElementById('notification-message-text');

    // Limpiar cualquier timeout existente
    if (currentTimeout) {
      clearTimeout(currentTimeout);
      currentTimeout = null;
    }

    // Actualizar el mensaje y el tipo
    messageText.textContent = message;
    container.className = `notification-message notification-message--${type}`;
    
    // Mostrar el overlay y la notificación
    overlay.style.display = 'block';
    container.style.display = 'flex';
    
    // Forzar un reflow para asegurar que las transiciones funcionen
    void overlay.offsetWidth;
    void container.offsetWidth;
    
    // Activar las transiciones
    overlay.style.opacity = '1';
    container.style.opacity = '1';

    // Auto-ocultar solo si la duración es mayor que 0
    if (duration > 0) {
      currentTimeout = setTimeout(hideNotification, duration);
    }
  }

  // Función para ocultar la notificación
  function hideNotification() {
    const overlay = document.getElementById('notification-overlay');
    const container = document.getElementById('notification-message');
    
    if (container && overlay) {
      // Iniciar la transición de salida
      overlay.style.opacity = '0';
      container.style.opacity = '0';

      // Ocultar después de completar la transición
      setTimeout(() => {
        overlay.style.display = 'none';
        container.style.display = 'none';
      }, 300);
    }

    // Limpiar cualquier timeout existente
    if (currentTimeout) {
      clearTimeout(currentTimeout);
      currentTimeout = null;
    }
  }

  // Función global simplificada para mostrar notificaciones
  function notification(message, type = 'error', duration = 0) {
    // Si el documento está listo, mostrar inmediatamente
    if (document.readyState !== 'loading') {
      showNotification(message, type, duration);
    } else {
      // Si no, esperar a que el documento esté listo
      document.addEventListener('DOMContentLoaded', function () {
        showNotification(message, type, duration);
      });
    }
  }

  // Método para ocultar la notificación actual
  notification.hide = hideNotification;

  // Inicializar cuando el documento esté listo
  function init() {
    addStyles();
    createNotificationElements();
  }

  // Inicializar cuando el documento esté listo
  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  // Exponer la función globalmente
  window.notification = notification;
})();
